import Page from '@ulta/core/components/Page/Page';

export default Page;